import { render, staticRenderFns } from "./return-label.vue?vue&type=template&id=3a934cbc&scoped=true"
import script from "./return-label.vue?vue&type=script&lang=js"
export * from "./return-label.vue?vue&type=script&lang=js"
import style0 from "./return-label.vue?vue&type=style&index=0&id=3a934cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a934cbc",
  null
  
)

export default component.exports